export const eligibleSurchargeOffersQueryKeys = {
  all: ['lere', 'eligible-surcharge-offers'] as const,
  list: () => [...eligibleSurchargeOffersQueryKeys.all, 'list'] as const,
};
